@file:OptIn(InternalResourceApi::class)

package com.xtream.sharedResources.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.RegionQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.xtream.sharedResources.resources/"

@delegate:ResourceContentHash(1_917_263_870)
public val Res.string.E_Mail: StringResource by lazy {
      StringResource("string:E_Mail", "E_Mail", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 10, 58),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 10, 30),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 10, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 22),
      ))
    }

@delegate:ResourceContentHash(532_036_184)
public val Res.string.account_text: StringResource by lazy {
      StringResource("string:account_text", "account_text", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 69, 36),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 41, 36),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 37, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33, 32),
      ))
    }

@delegate:ResourceContentHash(368_136_222)
public val Res.string.activate: StringResource by lazy {
      StringResource("string:activate", "activate", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 106, 32),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 78, 40),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 66, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66, 28),
      ))
    }

@delegate:ResourceContentHash(1_040_739_611)
public val Res.string.activation_code: StringResource by lazy {
      StringResource("string:activation_code", "activation_code", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 240, 51),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 232, 59),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 176, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 188, 43),
      ))
    }

@delegate:ResourceContentHash(-541_973_586)
public val Res.string.activation_code_length_error: StringResource by lazy {
      StringResource("string:activation_code_length_error", "activation_code_length_error", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 139, 100),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 119, 112),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 99, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95, 92),
      ))
    }

@delegate:ResourceContentHash(1_852_344_560)
public val Res.string.active_connections_text: StringResource by lazy {
      StringResource("string:active_connections_text", "active_connections_text", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 292, 75),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 292, 91),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 224, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232, 55),
      ))
    }

@delegate:ResourceContentHash(917_234_566)
public val Res.string.activity_open_fail: StringResource by lazy {
      StringResource("string:activity_open_fail", "activity_open_fail", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 368, 74),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 384, 90),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 280, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288, 66),
      ))
    }

@delegate:ResourceContentHash(3_032_669)
public val Res.string.add_to_favorites: StringResource by lazy {
      StringResource("string:add_to_favorites", "add_to_favorites", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 443, 64),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 475, 80),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 331, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 355, 48),
      ))
    }

@delegate:ResourceContentHash(-530_363_181)
public val Res.string.added_to_favorites: StringResource by lazy {
      StringResource("string:added_to_favorites", "added_to_favorites", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 508, 86),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 556, 82),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 388, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 404, 50),
      ))
    }

@delegate:ResourceContentHash(-1_065_275_758)
public val Res.string.always_use_https: StringResource by lazy {
      StringResource("string:always_use_https", "always_use_https", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 685, 40),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 761, 92),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 533, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 529, 40),
      ))
    }

@delegate:ResourceContentHash(-831_594_084)
public val Res.string.always_use_https_desc: StringResource by lazy {
      StringResource("string:always_use_https_desc", "always_use_https_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 595, 89),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 639, 121),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 455, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 455, 73),
      ))
    }

@delegate:ResourceContentHash(-1_221_942_887)
public val Res.string.app_logo_login_screen: StringResource by lazy {
      StringResource("string:app_logo_login_screen", "app_logo_login_screen", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 726, 101),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 854, 109),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 582, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 570, 65),
      ))
    }

@delegate:ResourceContentHash(-315_138_328)
public val Res.string.audio_traks: StringResource by lazy {
      StringResource("string:audio_traks", "audio_traks", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 828, 55),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 964, 55),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 660, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 636, 35),
      ))
    }

@delegate:ResourceContentHash(162_358_708)
public val Res.string.banner_image: StringResource by lazy {
      StringResource("string:banner_image", "banner_image", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 884, 60),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1020, 56),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 700, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 672, 40),
      ))
    }

@delegate:ResourceContentHash(505_436_758)
public val Res.string.browse: StringResource by lazy {
      StringResource("string:browse", "browse", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 713, 22),
      ))
    }

@delegate:ResourceContentHash(1_720_963_100)
public val Res.string.carousel_slideshow: StringResource by lazy {
      StringResource("string:carousel_slideshow", "carousel_slideshow", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 945, 50),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1077, 106),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 749, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 736, 50),
      ))
    }

@delegate:ResourceContentHash(-899_362_256)
public val Res.string.cast: StringResource by lazy {
      StringResource("string:cast", "cast", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 996, 36),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1184, 40),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 796, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 787, 20),
      ))
    }

@delegate:ResourceContentHash(1_271_785_803)
public val Res.string.categories: StringResource by lazy {
      StringResource("string:categories", "categories", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1033, 34),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1225, 42),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 817, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 808, 34),
      ))
    }

@delegate:ResourceContentHash(32_191_694)
public val Res.string.category: StringResource by lazy {
      StringResource("string:category", "category", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1068, 32),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1268, 28),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 848, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 843, 28),
      ))
    }

@delegate:ResourceContentHash(-334_609_547)
public val Res.string.chose_app_theme: StringResource by lazy {
      StringResource("string:chose_app_theme", "chose_app_theme", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 872, 47),
      ))
    }

@delegate:ResourceContentHash(-2_065_123_982)
public val Res.string.chose_decoder_type: StringResource by lazy {
      StringResource("string:chose_decoder_type", "chose_decoder_type", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1101, 54),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1297, 66),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 877, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 920, 46),
      ))
    }

@delegate:ResourceContentHash(1_598_217_164)
public val Res.string.chose_language: StringResource by lazy {
      StringResource("string:chose_language", "chose_language", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1156, 58),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1364, 86),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 932, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 967, 54),
      ))
    }

@delegate:ResourceContentHash(-751_461_780)
public val Res.string.clear_watched_live_tv_history: StringResource by lazy {
      StringResource("string:clear_watched_live_tv_history", "clear_watched_live_tv_history", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1215, 105),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1451, 145),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 999, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1022, 77),
      ))
    }

@delegate:ResourceContentHash(1_319_635_551)
public val Res.string.clear_watched_movies_history: StringResource by lazy {
      StringResource("string:clear_watched_movies_history", "clear_watched_movies_history", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1321, 92),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1597, 72),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1085, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1100, 76),
      ))
    }

@delegate:ResourceContentHash(-2_043_704_817)
public val Res.string.clear_watched_series_history: StringResource by lazy {
      StringResource("string:clear_watched_series_history", "clear_watched_series_history", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1414, 96),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1670, 120),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1158, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1177, 76),
      ))
    }

@delegate:ResourceContentHash(1_262_206_615)
public val Res.string.close: StringResource by lazy {
      StringResource("string:close", "close", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1554, 29),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1850, 29),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1286, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1297, 21),
      ))
    }

@delegate:ResourceContentHash(-2_121_242_806)
public val Res.string.closed_caption: StringResource by lazy {
      StringResource("string:closed_caption", "closed_caption", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1511, 42),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1791, 58),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1239, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1254, 42),
      ))
    }

@delegate:ResourceContentHash(-2_111_121_731)
public val Res.string.code_validation_error: StringResource by lazy {
      StringResource("string:code_validation_error", "code_validation_error", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1584, 69),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1880, 81),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1308, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1319, 61),
      ))
    }

@delegate:ResourceContentHash(1_595_196_698)
public val Res.string.confirm_opening_in_browser: StringResource by lazy {
      StringResource("string:confirm_opening_in_browser", "confirm_opening_in_browser", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1654, 146),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 1962, 150),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1378, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1381, 118),
      ))
    }

@delegate:ResourceContentHash(1_031_141_824)
public val Res.string.contact_us: StringResource by lazy {
      StringResource("string:contact_us", "contact_us", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1801, 38),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2113, 70),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1509, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1500, 34),
      ))
    }

@delegate:ResourceContentHash(-226_436_724)
public val Res.string.created_date_text: StringResource by lazy {
      StringResource("string:created_date_text", "created_date_text", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1840, 61),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2184, 69),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1560, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1535, 41),
      ))
    }

@delegate:ResourceContentHash(1_628_074_802)
public val Res.string.date_time: StringResource by lazy {
      StringResource("string:date_time", "date_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1577, 45),
      ))
    }

@delegate:ResourceContentHash(-968_234_145)
public val Res.string.device_id: StringResource by lazy {
      StringResource("string:device_id", "device_id", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1902, 33),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2254, 37),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1614, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1623, 21),
      ))
    }

@delegate:ResourceContentHash(-1_781_510_550)
public val Res.string.director: StringResource by lazy {
      StringResource("string:director", "director", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1936, 28),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2292, 40),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1644, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1645, 28),
      ))
    }

@delegate:ResourceContentHash(1_348_232_999)
public val Res.string.discover: StringResource by lazy {
      StringResource("string:discover", "discover", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1674, 28),
      ))
    }

@delegate:ResourceContentHash(758_845_964)
public val Res.string.down_arrow: StringResource by lazy {
      StringResource("string:down_arrow", "down_arrow", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 1965, 42),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2333, 50),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1673, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1703, 34),
      ))
    }

@delegate:ResourceContentHash(-626_381_363)
public val Res.string.enter_activation_code: StringResource by lazy {
      StringResource("string:enter_activation_code", "enter_activation_code", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2008, 69),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2384, 85),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1712, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1738, 57),
      ))
    }

@delegate:ResourceContentHash(2_040_595_326)
public val Res.string.episodes: StringResource by lazy {
      StringResource("string:episodes", "episodes", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2078, 36),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2470, 36),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1782, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1796, 28),
      ))
    }

@delegate:ResourceContentHash(-1_026_157_004)
public val Res.string.exp_date_text: StringResource by lazy {
      StringResource("string:exp_date_text", "exp_date_text", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2115, 57),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2507, 65),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1807, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1825, 37),
      ))
    }

@delegate:ResourceContentHash(838_424_580)
public val Res.string.fast_forward: StringResource by lazy {
      StringResource("string:fast_forward", "fast_forward", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2173, 48),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2573, 56),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1857, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1863, 36),
      ))
    }

@delegate:ResourceContentHash(-1_699_843_856)
public val Res.string.fast_rewind: StringResource by lazy {
      StringResource("string:fast_rewind", "fast_rewind", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2222, 47),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2630, 63),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1898, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1900, 35),
      ))
    }

@delegate:ResourceContentHash(-1_524_260_144)
public val Res.string.filter: StringResource by lazy {
      StringResource("string:filter", "filter", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2270, 30),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2694, 34),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1934, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1936, 22),
      ))
    }

@delegate:ResourceContentHash(-227_060_761)
public val Res.string.footer_logo: StringResource by lazy {
      StringResource("string:footer_logo", "footer_logo", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2301, 51),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2729, 63),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 1965, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1959, 35),
      ))
    }

@delegate:ResourceContentHash(1_780_435_035)
public val Res.string.force_player_refresh_on_update: StringResource by lazy {
      StringResource("string:force_player_refresh_on_update", "force_player_refresh_on_update", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2488, 114),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2956, 134),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2124, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2098, 90),
      ))
    }

@delegate:ResourceContentHash(106_595_268)
public val Res.string.force_player_refresh_on_update_summary: StringResource by lazy {
      StringResource("string:force_player_refresh_on_update_summary", "force_player_refresh_on_update_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2353, 134),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 2793, 162),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2017, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1995, 102),
      ))
    }

@delegate:ResourceContentHash(2_085_021_077)
public val Res.string.forward: StringResource by lazy {
      StringResource("string:forward", "forward", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2603, 31),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3091, 39),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2227, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2189, 27),
      ))
    }

@delegate:ResourceContentHash(-1_610_156_067)
public val Res.string.full_screen: StringResource by lazy {
      StringResource("string:full_screen", "full_screen", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2635, 47),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3131, 43),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2255, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2217, 35),
      ))
    }

@delegate:ResourceContentHash(962_832_100)
public val Res.string.general: StringResource by lazy {
      StringResource("string:general", "general", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2683, 23),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3175, 27),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2295, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2253, 27),
      ))
    }

@delegate:ResourceContentHash(-1_571_523_166)
public val Res.string.genre: StringResource by lazy {
      StringResource("string:genre", "genre", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2707, 21),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3203, 25),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2323, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2281, 21),
      ))
    }

@delegate:ResourceContentHash(1_030_596_921)
public val Res.string.goto_home: StringResource by lazy {
      StringResource("string:goto_home", "goto_home", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2729, 29),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3229, 33),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2345, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2303, 25),
      ))
    }

@delegate:ResourceContentHash(607_361_901)
public val Res.string.header_backdrop: StringResource by lazy {
      StringResource("string:header_backdrop", "header_backdrop", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2759, 71),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3263, 59),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2379, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2329, 43),
      ))
    }

@delegate:ResourceContentHash(10_073_566)
public val Res.string.home: StringResource by lazy {
      StringResource("string:home", "home", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2831, 36),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3323, 28),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2427, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2373, 20),
      ))
    }

@delegate:ResourceContentHash(876_915_511)
public val Res.string.is_trial_text: StringResource by lazy {
      StringResource("string:is_trial_text", "is_trial_text", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2868, 49),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3352, 61),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2448, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2394, 33),
      ))
    }

@delegate:ResourceContentHash(-176_086_832)
public val Res.string.language: StringResource by lazy {
      StringResource("string:language", "language", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2918, 32),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3414, 28),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2498, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2428, 28),
      ))
    }

@delegate:ResourceContentHash(1_042_590_177)
public val Res.string.last_refresh: StringResource by lazy {
      StringResource("string:last_refresh", "last_refresh", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2951, 44),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3443, 68),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2523, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2457, 36),
      ))
    }

@delegate:ResourceContentHash(-145_253_078)
public val Res.string.live: StringResource by lazy {
      StringResource("string:live", "live", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3121, 28),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3605, 36),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2633, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2551, 20),
      ))
    }

@delegate:ResourceContentHash(-731_755_239)
public val Res.string.live_tab: StringResource by lazy {
      StringResource("string:live_tab", "live_tab", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 2996, 76),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3512, 52),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2568, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2494, 28),
      ))
    }

@delegate:ResourceContentHash(35_462_781)
public val Res.string.live_tv: StringResource by lazy {
      StringResource("string:live_tv", "live_tv", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3073, 47),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3565, 39),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2605, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2523, 27),
      ))
    }

@delegate:ResourceContentHash(-341_535_212)
public val Res.string.loading_branch_logo_image: StringResource by lazy {
      StringResource("string:loading_branch_logo_image", "loading_branch_logo_image", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3150, 85),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3642, 85),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2654, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2572, 69),
      ))
    }

@delegate:ResourceContentHash(-1_061_169_293)
public val Res.string.login: StringResource by lazy {
      StringResource("string:login", "login", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3455, 45),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3967, 45),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2871, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2793, 21),
      ))
    }

@delegate:ResourceContentHash(425_152_994)
public val Res.string.login_to_your_account: StringResource by lazy {
      StringResource("string:login_to_your_account", "login_to_your_account", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3236, 81),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3728, 89),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2720, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2642, 57),
      ))
    }

@delegate:ResourceContentHash(-584_734_413)
public val Res.string.login_via_account_or_activation_code: StringResource by lazy {
      StringResource("string:login_via_account_or_activation_code", "login_via_account_or_activation_code", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3318, 136),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 3818, 148),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2774, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2700, 92),
      ))
    }

@delegate:ResourceContentHash(285_985_012)
public val Res.string.logout: StringResource by lazy {
      StringResource("string:logout", "logout", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3501, 46),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4013, 46),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2897, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2815, 22),
      ))
    }

@delegate:ResourceContentHash(441_287_639)
public val Res.string.max_connections_text: StringResource by lazy {
      StringResource("string:max_connections_text", "max_connections_text", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3548, 76),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4060, 80),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2924, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2838, 48),
      ))
    }

@delegate:ResourceContentHash(1_110_348_602)
public val Res.string.may_like: StringResource by lazy {
      StringResource("string:may_like", "may_like", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3625, 56),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4141, 80),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 2993, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2887, 44),
      ))
    }

@delegate:ResourceContentHash(1_001_758_952)
public val Res.string.menu: StringResource by lazy {
      StringResource("string:menu", "menu", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3682, 32),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4222, 28),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3054, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2932, 20),
      ))
    }

@delegate:ResourceContentHash(1_966_599_761)
public val Res.string.move: StringResource by lazy {
      StringResource("string:move", "move", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3715, 20),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4251, 36),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3075, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2953, 20),
      ))
    }

@delegate:ResourceContentHash(1_109_797_833)
public val Res.string.movie_tab: StringResource by lazy {
      StringResource("string:movie_tab", "movie_tab", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3736, 65),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4288, 53),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3100, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2974, 33),
      ))
    }

@delegate:ResourceContentHash(-427_353_343)
public val Res.string.movies: StringResource by lazy {
      StringResource("string:movies", "movies", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3802, 34),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4342, 38),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3142, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3008, 22),
      ))
    }

@delegate:ResourceContentHash(-730_328_739)
public val Res.string.nav_bar_search: StringResource by lazy {
      StringResource("string:nav_bar_search", "nav_bar_search", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3837, 70),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4381, 82),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3165, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3031, 50),
      ))
    }

@delegate:ResourceContentHash(-74_834_308)
public val Res.string.nav_bar_settings: StringResource by lazy {
      StringResource("string:nav_bar_settings", "nav_bar_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3908, 80),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4464, 84),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3232, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3082, 52),
      ))
    }

@delegate:ResourceContentHash(-1_350_896_425)
public val Res.string.need_help: StringResource by lazy {
      StringResource("string:need_help", "need_help", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 3989, 61),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4549, 69),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3301, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3135, 33),
      ))
    }

@delegate:ResourceContentHash(-383_146_105)
public val Res.string.no: StringResource by lazy {
      StringResource("string:no", "no", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4202, 18),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4810, 26),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3458, 14),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3264, 14),
      ))
    }

@delegate:ResourceContentHash(1_687_742_330)
public val Res.string.no_results: StringResource by lazy {
      StringResource("string:no_results", "no_results", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4051, 50),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4619, 82),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3347, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3169, 42),
      ))
    }

@delegate:ResourceContentHash(1_817_954_166)
public val Res.string.no_server_found: StringResource by lazy {
      StringResource("string:no_server_found", "no_server_found", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4102, 99),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4702, 107),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3390, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3212, 51),
      ))
    }

@delegate:ResourceContentHash(1_112_877_515)
public val Res.string.open_close_categories: StringResource by lazy {
      StringResource("string:open_close_categories", "open_close_categories", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4221, 81),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4837, 113),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3473, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3279, 61),
      ))
    }

@delegate:ResourceContentHash(-1_380_158_918)
public val Res.string.overflow_hide: StringResource by lazy {
      StringResource("string:overflow_hide", "overflow_hide", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4303, 57),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 4951, 77),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3551, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3341, 41),
      ))
    }

@delegate:ResourceContentHash(2_015_028_486)
public val Res.string.overflow_menu: StringResource by lazy {
      StringResource("string:overflow_menu", "overflow_menu", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4361, 53),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5029, 49),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3597, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3383, 41),
      ))
    }

@delegate:ResourceContentHash(-1_787_624_967)
public val Res.string.overview: StringResource by lazy {
      StringResource("string:overview", "overview", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4415, 40),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5079, 32),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3639, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3425, 28),
      ))
    }

@delegate:ResourceContentHash(-39_185_897)
public val Res.string.pause: StringResource by lazy {
      StringResource("string:pause", "pause", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4456, 41),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5112, 37),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3668, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3454, 21),
      ))
    }

@delegate:ResourceContentHash(1_756_102_290)
public val Res.string.play: StringResource by lazy {
      StringResource("string:play", "play", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4740, 28),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5428, 36),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3888, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3688, 20),
      ))
    }

@delegate:ResourceContentHash(-503_151_094)
public val Res.string.player: StringResource by lazy {
      StringResource("string:player", "player", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4546, 30),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5214, 34),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3746, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3512, 22),
      ))
    }

@delegate:ResourceContentHash(-1_407_970_938)
public val Res.string.player_view: StringResource by lazy {
      StringResource("string:player_view", "player_view", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4498, 47),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5150, 63),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3698, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3476, 35),
      ))
    }

@delegate:ResourceContentHash(3_560_622)
public val Res.string.playlist_updated: StringResource by lazy {
      StringResource("string:playlist_updated", "playlist_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4687, 52),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5347, 80),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3835, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3609, 48),
      ))
    }

@delegate:ResourceContentHash(-21_903_662)
public val Res.string.playlist_updated_desc: StringResource by lazy {
      StringResource("string:playlist_updated_desc", "playlist_updated_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4577, 109),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5249, 97),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3769, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3535, 73),
      ))
    }

@delegate:ResourceContentHash(1_624_641_444)
public val Res.string.playlists: StringResource by lazy {
      StringResource("string:playlists", "playlists", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3658, 29),
      ))
    }

@delegate:ResourceContentHash(963_504_290)
public val Res.string.pro_message: StringResource by lazy {
      StringResource("string:pro_message", "pro_message", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4769, 71),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5465, 99),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3913, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3709, 67),
      ))
    }

@delegate:ResourceContentHash(-1_667_683_432)
public val Res.string.prompt_password: StringResource by lazy {
      StringResource("string:prompt_password", "prompt_password", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4841, 51),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5565, 51),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 3989, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3777, 35),
      ))
    }

@delegate:ResourceContentHash(-1_205_890_867)
public val Res.string.qr_code: StringResource by lazy {
      StringResource("string:qr_code", "qr_code", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4893, 27),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5617, 31),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4025, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3813, 27),
      ))
    }

@delegate:ResourceContentHash(-766_138_448)
public val Res.string.recently_added_movies: StringResource by lazy {
      StringResource("string:recently_added_movies", "recently_added_movies", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 4921, 85),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5649, 81),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4053, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3841, 57),
      ))
    }

@delegate:ResourceContentHash(-1_412_218_098)
public val Res.string.recently_added_tv: StringResource by lazy {
      StringResource("string:recently_added_tv", "recently_added_tv", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5099, 85),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5827, 89),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4203, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3963, 49),
      ))
    }

@delegate:ResourceContentHash(-412_932_645)
public val Res.string.recently_added_tv_shows: StringResource by lazy {
      StringResource("string:recently_added_tv_shows", "recently_added_tv_shows", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5007, 91),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5731, 95),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4123, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3899, 63),
      ))
    }

@delegate:ResourceContentHash(1_417_146_120)
public val Res.string.recently_watched: StringResource by lazy {
      StringResource("string:recently_watched", "recently_watched", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5185, 72),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5917, 64),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4269, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4013, 48),
      ))
    }

@delegate:ResourceContentHash(1_349_085_433)
public val Res.string.redeem: StringResource by lazy {
      StringResource("string:redeem", "redeem", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5258, 34),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 5982, 38),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4330, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4062, 22),
      ))
    }

@delegate:ResourceContentHash(-534_317_144)
public val Res.string.refresh: StringResource by lazy {
      StringResource("string:refresh", "refresh", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5462, 31),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6210, 43),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4506, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4206, 27),
      ))
    }

@delegate:ResourceContentHash(107_265_973)
public val Res.string.refresh_data_interval: StringResource by lazy {
      StringResource("string:refresh_data_interval", "refresh_data_interval", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5293, 89),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6021, 101),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4373, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4085, 65),
      ))
    }

@delegate:ResourceContentHash(-2_052_409_388)
public val Res.string.refresh_playlist_title: StringResource by lazy {
      StringResource("string:refresh_playlist_title", "refresh_playlist_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5383, 78),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6123, 86),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4443, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4151, 54),
      ))
    }

@delegate:ResourceContentHash(1_845_604_142)
public val Res.string.related: StringResource by lazy {
      StringResource("string:related", "related", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5494, 35),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6254, 47),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4538, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4234, 27),
      ))
    }

@delegate:ResourceContentHash(1_091_672_563)
public val Res.string.remove_from_favorites: StringResource by lazy {
      StringResource("string:remove_from_favorites", "remove_from_favorites", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5530, 69),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6302, 81),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4566, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4262, 57),
      ))
    }

@delegate:ResourceContentHash(-242_186_854)
public val Res.string.removed_from_favorites: StringResource by lazy {
      StringResource("string:removed_from_favorites", "removed_from_favorites", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), RegionQualifier("IQ"), ), "${MD}values-ar-rIQ/strings.commonMain.cvr", 5600, 86),
        ResourceItem(setOf(LanguageQualifier("ckb"), RegionQualifier("IQ"), ), "${MD}values-ckb-rIQ/strings.commonMain.cvr", 6384, 78),
        ResourceItem(setOf(LanguageQualifier("kmr"), RegionQualifier("TR"), ), "${MD}values-kmr-rTR/strings.commonMain.cvr", 4620, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4320, 62),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("E_Mail", Res.string.E_Mail)
  map.put("account_text", Res.string.account_text)
  map.put("activate", Res.string.activate)
  map.put("activation_code", Res.string.activation_code)
  map.put("activation_code_length_error", Res.string.activation_code_length_error)
  map.put("active_connections_text", Res.string.active_connections_text)
  map.put("activity_open_fail", Res.string.activity_open_fail)
  map.put("add_to_favorites", Res.string.add_to_favorites)
  map.put("added_to_favorites", Res.string.added_to_favorites)
  map.put("always_use_https", Res.string.always_use_https)
  map.put("always_use_https_desc", Res.string.always_use_https_desc)
  map.put("app_logo_login_screen", Res.string.app_logo_login_screen)
  map.put("audio_traks", Res.string.audio_traks)
  map.put("banner_image", Res.string.banner_image)
  map.put("browse", Res.string.browse)
  map.put("carousel_slideshow", Res.string.carousel_slideshow)
  map.put("cast", Res.string.cast)
  map.put("categories", Res.string.categories)
  map.put("category", Res.string.category)
  map.put("chose_app_theme", Res.string.chose_app_theme)
  map.put("chose_decoder_type", Res.string.chose_decoder_type)
  map.put("chose_language", Res.string.chose_language)
  map.put("clear_watched_live_tv_history", Res.string.clear_watched_live_tv_history)
  map.put("clear_watched_movies_history", Res.string.clear_watched_movies_history)
  map.put("clear_watched_series_history", Res.string.clear_watched_series_history)
  map.put("close", Res.string.close)
  map.put("closed_caption", Res.string.closed_caption)
  map.put("code_validation_error", Res.string.code_validation_error)
  map.put("confirm_opening_in_browser", Res.string.confirm_opening_in_browser)
  map.put("contact_us", Res.string.contact_us)
  map.put("created_date_text", Res.string.created_date_text)
  map.put("date_time", Res.string.date_time)
  map.put("device_id", Res.string.device_id)
  map.put("director", Res.string.director)
  map.put("discover", Res.string.discover)
  map.put("down_arrow", Res.string.down_arrow)
  map.put("enter_activation_code", Res.string.enter_activation_code)
  map.put("episodes", Res.string.episodes)
  map.put("exp_date_text", Res.string.exp_date_text)
  map.put("fast_forward", Res.string.fast_forward)
  map.put("fast_rewind", Res.string.fast_rewind)
  map.put("filter", Res.string.filter)
  map.put("footer_logo", Res.string.footer_logo)
  map.put("force_player_refresh_on_update", Res.string.force_player_refresh_on_update)
  map.put("force_player_refresh_on_update_summary", Res.string.force_player_refresh_on_update_summary)
  map.put("forward", Res.string.forward)
  map.put("full_screen", Res.string.full_screen)
  map.put("general", Res.string.general)
  map.put("genre", Res.string.genre)
  map.put("goto_home", Res.string.goto_home)
  map.put("header_backdrop", Res.string.header_backdrop)
  map.put("home", Res.string.home)
  map.put("is_trial_text", Res.string.is_trial_text)
  map.put("language", Res.string.language)
  map.put("last_refresh", Res.string.last_refresh)
  map.put("live", Res.string.live)
  map.put("live_tab", Res.string.live_tab)
  map.put("live_tv", Res.string.live_tv)
  map.put("loading_branch_logo_image", Res.string.loading_branch_logo_image)
  map.put("login", Res.string.login)
  map.put("login_to_your_account", Res.string.login_to_your_account)
  map.put("login_via_account_or_activation_code", Res.string.login_via_account_or_activation_code)
  map.put("logout", Res.string.logout)
  map.put("max_connections_text", Res.string.max_connections_text)
  map.put("may_like", Res.string.may_like)
  map.put("menu", Res.string.menu)
  map.put("move", Res.string.move)
  map.put("movie_tab", Res.string.movie_tab)
  map.put("movies", Res.string.movies)
  map.put("nav_bar_search", Res.string.nav_bar_search)
  map.put("nav_bar_settings", Res.string.nav_bar_settings)
  map.put("need_help", Res.string.need_help)
  map.put("no", Res.string.no)
  map.put("no_results", Res.string.no_results)
  map.put("no_server_found", Res.string.no_server_found)
  map.put("open_close_categories", Res.string.open_close_categories)
  map.put("overflow_hide", Res.string.overflow_hide)
  map.put("overflow_menu", Res.string.overflow_menu)
  map.put("overview", Res.string.overview)
  map.put("pause", Res.string.pause)
  map.put("play", Res.string.play)
  map.put("player", Res.string.player)
  map.put("player_view", Res.string.player_view)
  map.put("playlist_updated", Res.string.playlist_updated)
  map.put("playlist_updated_desc", Res.string.playlist_updated_desc)
  map.put("playlists", Res.string.playlists)
  map.put("pro_message", Res.string.pro_message)
  map.put("prompt_password", Res.string.prompt_password)
  map.put("qr_code", Res.string.qr_code)
  map.put("recently_added_movies", Res.string.recently_added_movies)
  map.put("recently_added_tv", Res.string.recently_added_tv)
  map.put("recently_added_tv_shows", Res.string.recently_added_tv_shows)
  map.put("recently_watched", Res.string.recently_watched)
  map.put("redeem", Res.string.redeem)
  map.put("refresh", Res.string.refresh)
  map.put("refresh_data_interval", Res.string.refresh_data_interval)
  map.put("refresh_playlist_title", Res.string.refresh_playlist_title)
  map.put("related", Res.string.related)
  map.put("remove_from_favorites", Res.string.remove_from_favorites)
  map.put("removed_from_favorites", Res.string.removed_from_favorites)
}
